import header from "./01-Küche-Grundriss-Schmiede.jpg";
import section1 from "./06-Badezimmer-Obergeschoss-Grundriss.jpg";
import section2 from "./03-Flur,Grundriss-Erdgeschoss.jpg";
import section3 from "./05-Grundriss-Schmiede-Obergeschoss-Wohnzimmer.jpg";
import section4 from "./04-Grundriss-Holzboden-Erdgeschoss.jpg";
import section5 from "./01-Hausansicht-Grundriss-Schmiede.jpg";
import section6 from "./02-Badezimmer-Grundriss-Erdgeschoss.jpg";

export { header, section1, section2, section3, section4, section5, section6 };
